import React from "react";
import { UICheckbox } from "ui";
import { useAppDispatch, useAppSelector } from "../../../../hooks/ReduxHooks";
import {
  removeActiveDisplayFields,
  setActiveDisplayFields,
} from "../../../../store/slices/PagePaginagionSlice";
import { DISPLAY_TABLE_FIELDS } from "../../../../constants/consts";
import { t } from "i18next";

interface displayFieldCheckboxProps {
  displayItem: string;
}

export const DisplayFieldCheckbox = (props: displayFieldCheckboxProps) => {
  const { displayItem } = props;
  const { activeDisplayFields } = useAppSelector((state) => state.page);
  const dispatch = useAppDispatch();
  const isChecked = activeDisplayFields.includes(displayItem);

  const handleOnChange = () => {
    if (isChecked) {
      dispatch(removeActiveDisplayFields(displayItem));
      return;
    }

    dispatch(setActiveDisplayFields(displayItem));
  };

  return (
    <label className="catalogControlAnt__optionRow">
      <UICheckbox
        checked={isChecked}
        onChange={handleOnChange}
        className="catalogControlAnt__optionCheckbox"
      />
      <span className="catalogControlAnt__optionLabel">
        {t(DISPLAY_TABLE_FIELDS[displayItem])}
      </span>
    </label>
  );
};
